













































































































































































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import AmetrasTextFieldTemplate from '@/fields/text/AmetrasTextFieldTemplate.vue';
import AmetrasNumberFieldTemplate from '@/fields/text/AmetrasNumberFieldTemplate.vue';
import AmetrasCheckBoxTemplate from '@/fields/checkbox/AmetrasCheckBoxTemplate.vue';
import AmetrasDateFieldTemplate from '@/fields/date/AmetrasDateFieldTemplate.vue';
import {FIELD_EVENTS_INSTANCE, VueOnMapType} from '@/fields/field-events';
import AmetrasMonthFieldTemplate from '@/fields/date/AmetrasMonthFieldTemplate.vue';
import AmetrasDateTimeFieldTemplate from '@/fields/datetime/AmetrasDateTimeFieldTemplate.vue';
import AmetrasDurationFieldTemplate from '@/fields/duration/AmetrasDurationFieldTemplate.vue';
import AmetrasSelectFieldTemplate from '@/fields/select/AmetrasSelectFieldTemplate.vue';
import AmetrasEmailFieldTemplate from '@/fields/text/AmetrasEmailFieldTemplate.vue';
import AmetrasTextAreaFieldTemplate from '@/fields/text-area/AmetrasTextAreaFieldTemplate.vue';
import AmetrasTextModuleFieldTemplate from '@/fields/text-area/AmetrasTextModuleFieldTemplate.vue';
import AmetrasTimeFieldTemplate from '@/fields/time/AmetrasTimeFieldTemplate.vue';
import AmetrasTimeWithSecondsFieldTemplate from '@/fields/time/AmetrasTimeWithSecondsFieldTemplate.vue';
import AmetrasDateWeekNumberFieldTemplate from '@/fields/weeknumber/AmetrasDateWeekNumberFieldTemplate.vue';
import AmetrasFormularWrapper from '@/views/AmetrasFormularWrapper.vue';
import AmetrasSwitchTemplate from '@/fields/switch/AmetrasSwitchTemplate.vue';
import AmetrasTextAreaMonoSpaceGridFieldTemplate from '@/fields/text-area/AmetrasTextAreaMonoSpaceGridFieldTemplate.vue';
import AmetrasEmailListFieldTemplate from '@/fields/text/AmetrasEmailListFieldTemplate.vue';
import AmetrasAlertTemplate from '@/fields/alert/AmetrasAlertTemplate.vue';
import AmetrasPhoneFieldTemplate from '@/fields/text/AmetrasPhoneFieldTemplate.vue';

@Component({
  components: {
    AmetrasPhoneFieldTemplate,
    AmetrasTextAreaMonoSpaceGridFieldTemplate,
    AmetrasAlertTemplate,
    AmetrasSwitchTemplate,
    AmetrasFormularWrapper,
    AmetrasTextFieldTemplate,
    AmetrasCheckBoxTemplate,
    AmetrasNumberFieldTemplate,
    AmetrasDateFieldTemplate,
    AmetrasMonthFieldTemplate,
    AmetrasDateTimeFieldTemplate,
    AmetrasDurationFieldTemplate,
    AmetrasSelectFieldTemplate,
    AmetrasEmailFieldTemplate,
    AmetrasTextAreaFieldTemplate,
    AmetrasTextModuleFieldTemplate,
    AmetrasTimeFieldTemplate,
    AmetrasTimeWithSecondsFieldTemplate,
    AmetrasDateWeekNumberFieldTemplate,
    AmetrasEmailListFieldTemplate
  }
})
export default class FieldTesterTemplate extends Vue {

  eventLog: string = '';

  formValid: boolean = true;

  readonly: boolean = false;
  disabled: boolean = false;
  required: boolean = false;

  textFieldModel: string | undefined | null = null;
  textFieldLengthModel: number | null = null;
  mailListFieldModel: string[] = [];
  mailFieldModel: string | undefined | null = null;
  phoneFieldModel: string | undefined | null = null;
  numberFieldModel: any = null;
  numberFieldMaxModel: number | null = null;
  numberFieldMinModel: number | null = null;
  dateFieldModel: string | undefined | null = null;
  checkboxFieldModel: any = null;
  monthFieldModel: any = null;
  dateTimeFieldModel: string | undefined | null = null;
  durationFieldModel: string | undefined | null = null;
  selectFieldModel: any = null;
  textAreaFieldModel: string | undefined | null = null;
  textAreaMonoSpaceGridFieldModel: string | undefined | null = null;
  textModuleFieldModel: string | undefined | null = null;
  timeFieldModel: string | undefined | null = null;
  timeWithSecondsModel: string | undefined | null = null;
  toggleFieldModel: string | boolean | undefined | null = null;
  weekNumberFieldModel: string | undefined | null = null;

  sticky: boolean = true;

  selectVals: DisguiseDto.SelectDto[] = [{
    text: 'Apfel',
    value: 'A'
  }, {
    text: 'Banane',
    value: 'B'
  }, {
    text: 'Zitrone',
    value: 'Z'
  }];

  passthroughAllEventsVueOnMap: VueOnMapType =
      FIELD_EVENTS_INSTANCE.buildPassthroughVueOnMapForAllEvents((eventName, eventArgs) => {
        this.logEvent(eventName, eventArgs);
      });

  $refs!: {
    formWrapper: AmetrasFormularWrapper
  };

  onSubmit() {
    this.$refs.formWrapper.validate();
  }

  logEvent(eventName: string, eventArgs: any) {
    this.eventLog = `${this.$moment().format('mm:ss.SSSS')} / ${eventName} / ${eventArgs}\n${this.eventLog}`;
  }

}
